import React from 'react';
import { FormattedMessage } from 'react-intl';
import Error from './Error';

export default () => (
    <Error>
        <FormattedMessage defaultMessage="Page not found." />
    </Error>
);
